import { createRouter, createWebHistory } from 'vue-router'
import { useAuth } from '@shared/composables/useAuth.js'

// Import views
import LoginView from '../views/LoginView.vue'
import CalculatorView from '../views/CalculatorView.vue'
import DashboardView from '../views/DashboardView.vue'
import CasesView from '../views/CasesView.vue'
import CaseFormView from '../views/CaseFormView.vue'
import CaseDetailView from '../views/CaseDetailView.vue'
import ScholarsView from '../views/ScholarsView.vue'
import ScholarQueueView from '../views/ScholarQueueView.vue'
import ScholarReviewView from '../views/ScholarReviewView.vue'
import SettingsView from '../views/SettingsView.vue'
import MessageHistoryView from '../views/MessageHistoryView.vue'
import ScholarMagicReviewView from '../views/ScholarMagicReviewView.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { requiresAuth: false },
  },
  {
    path: '/calculator',
    name: 'calculator',
    component: CalculatorView,
    meta: { requiresAuth: false },
  },
  {
    path: '/review',
    name: 'scholar-review-magic',
    component: ScholarMagicReviewView,
    meta: { requiresAuth: false },
  },
  {
    path: '/',
    name: 'home',
    // Unauthenticated → calculator, authenticated → dashboard
    redirect: () => {
      const token = localStorage.getItem('auth_token')
      return token ? '/dashboard' : '/calculator'
    },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView,
    meta: { requiresAuth: true },
  },
  {
    path: '/cases',
    name: 'cases',
    component: CasesView,
    meta: { requiresAuth: true },
  },
  {
    path: '/cases/new',
    name: 'case-new',
    component: CaseFormView,
    meta: { requiresAuth: true },
  },
  {
    path: '/cases/:id',
    name: 'case-detail',
    component: CaseDetailView,
    meta: { requiresAuth: true },
  },
  {
    path: '/scholars',
    name: 'scholars',
    component: ScholarsView,
    meta: { requiresAuth: true },
  },
  {
    path: '/scholar-queue',
    name: 'scholar-queue',
    component: ScholarQueueView,
    meta: { requiresAuth: true },
  },
  {
    path: '/scholar-queue/:id/review',
    name: 'scholar-review',
    component: ScholarReviewView,
    meta: { requiresAuth: true },
  },
  {
    path: '/settings',
    name: 'settings',
    component: SettingsView,
    meta: { requiresAuth: true },
  },
  {
    path: '/messages',
    name: 'messages',
    component: MessageHistoryView,
    meta: { requiresAuth: true },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Navigation guard - check authentication
// Allow login + calculator without auth
router.beforeEach(async (to, from, next) => {
  const { isAuthenticated, fetchMe, user } = useAuth()
  const { apiClient } = await import('@shared/utils/apiClient.js')

  // Public routes - always allow
  if (to.name === 'login' || to.name === 'calculator' || to.name === 'scholar-review-magic') {
    // If going to login and already authenticated, redirect to dashboard
    if (to.name === 'login' && isAuthenticated.value && user.value) {
      next({ name: 'dashboard' })
      return
    }
    next()
    return
  }

  // Route requires auth
  if (to.meta.requiresAuth) {
    if (!apiClient.isAuthenticated()) {
      next({ name: 'login', query: { redirect: to.fullPath } })
      return
    }

    // Token exists, fetch user info if not loaded
    if (!user.value) {
      try {
        await fetchMe()
      } catch (error) {
        apiClient.clearToken()
        next({ name: 'login', query: { redirect: to.fullPath } })
        return
      }
    }
  }

  next()
})

export default router
